export enum AbnFormStep {
  CONSENT = "ABN_CONSENT",
  FLOW_SELECT = "ABN_FLOW_SELECT",
  DIRECTOR = "ABN_DIRECTOR",
  COMPANY = "ABN_COMPANY",
  IDENTITY = "ABN_IDENTITY",
  CONFIRM = "ABN_CONFIRM",
  COMPLETE = "ABN_COMPLETE",
}

export const FORM_STEP_TO_PATH: Record<AbnFormStep, string> = {
  [AbnFormStep.CONSENT]: "consent",
  [AbnFormStep.FLOW_SELECT]: "flow-select",
  [AbnFormStep.DIRECTOR]: "director",
  [AbnFormStep.COMPANY]: "company",
  [AbnFormStep.IDENTITY]: "identity",
  [AbnFormStep.CONFIRM]: "confirm",
  [AbnFormStep.COMPLETE]: "complete",
};
